

























































































































































































































import {AxiosError, AxiosResponse} from 'axios';
import _ from 'lodash';
import moment from 'moment';
import numeral from 'numeral';
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Getter} from 'vuex-class';

import {Size} from '@/enums';
import {httpService} from '@/services';

import {CONFIG} from '@/config';
import {REPORT_GET_REPORTS} from '@/modules/neodash/store/modules/report/types';
import {PRINT_GET_PRINT_MODE} from '@/store/modules/print/types';

@Component
export default class Rap extends Vue {
  numeral = numeral;
  Size = Size;

  @Prop({required: true}) dataQuery: any;

  @Getter(REPORT_GET_REPORTS) reports: any;
  @Getter(PRINT_GET_PRINT_MODE) printMode: any;

  public reportData: Array<any> = [];
  public years: any = {};
  public evaluationMonth: string = '';

  public keyIndicators: any = {
    sales: {
      text: 'Sales',
      format: '0,0'
    },
    index: {
      text: 'Index',
      format: '0,0.00%'
    },
    discount: {
      text: 'Disc.',
      format: '0,0.0%'
    },
    mktShare: {
      text: 'M/S',
      format: '0,0.0%'
    },
    adp: {
      text: 'ADP',
      format: '0,0.0%'
    },
    lair: {
      text: 'LAIR',
      format: '$0,0.00'
    }
  };

  public get reportDataView() {
    return _(this.reportData)
        .groupBy((r: any) => r.region)
        .map((val: any, key: string) => ({
          region: key,
          aov: val[0].aov,
          dealers: val
        }))
        .orderBy((r: any) => r.region)
        .value();
  }

  public get reportFamilies() {
    return ['TOTAL', ..._([..._.keys(this.reportData[0].consolidateRapFamilyResults), ..._.keys(this.reportData[0].forecastRapFamilyResults)]).uniq().filter((v: any) => v !== 'TOTAL').value()];
  }

  public isDealerActive(dealer: any) {
    return dealer.dateClosing ? +(new Date(dealer.dateClosing)) <= +(new Date()) : true;
  }

  @Watch('dataQuery')
  public requestData() {
    const req = [
      httpService.http.post(`${CONFIG.URL.NEODASH_API}/api/dap/project/${this.dataQuery.projectId}/rap`)
    ];

    Promise.all(req)
        .then((res: Array<AxiosResponse>) => {
          const reportsData = _.filter(res[0].data, (d: any) => d.idAov === this.dataQuery.idAov);

          this.evaluationMonth = _(res[0].data[0].consolidate_RapFamilyResultsPerMonth)
              .orderBy('month')
              .orderBy('year')
              .last().monthName.substr(0, 3);

          _.forEach(reportsData, (reportData: any) => {
            _.forEach({
              'consolidateRapFamilyResults': 'consolidate_RapFamilyResults',
              'consolidateRapFamilyResultsPerMonth': 'consolidate_RapFamilyResultsPerMonth',
              'forecastRapFamilyResults': 'forecast_RapFamilyResults',
              'forecastRapFamilyResultsPerMonth': 'forecast_RapFamilyResultsPerMonth'
            }, (target: string, source: string) => {
              reportData[source] = _(reportData[target])
                  .orderBy((x: any) => x.familyName)
                  .groupBy((x: any) => x.familyName)
                  .reduce((acc1: any, val1: any, key1: string) => {
                    acc1[key1] = _(val1)
                        .groupBy((x: any) => x.year)
                        .reduce((acc2: any, val2: any, key2: string) => {
                          this.years[key2] = Number(key2);

                          if (source === 'consolidateRapFamilyResults' || source === 'forecastRapFamilyResults') {
                            acc2[key2] = val2[0];
                          } else {

                            acc2[key2] = _(_.range(0, 12)).map((month: any) => {
                              const val = _.find(val2, (v: any) => (v.month - 1) === month);

                              if (val) {
                                val.monthName = (moment.localeData() as any)._monthsShort[month];
                                return val;
                              } else {
                                return {
                                  month: month + 1,
                                  value: 0,
                                  year: +key2,
                                  monthName: (moment.localeData() as any)._monthsShort[month]
                                };
                              }
                            }).orderBy((val: any) => val.month).value();
                          }
                          return acc2;
                        }, {});
                    return acc1;
                  }, {});
            });
          });
          this.reportData = reportsData;
        })
        .catch((err: AxiosError) => console.log(err));
  }

  public created() {
    this.requestData();
  }
}
